import { Icon } from '@breezeventures/ui-kit/next/icon';

type FilePreviewProps = {
  isImage: boolean;
  previewUrl?: string;
};

export const FilePreview = ({ isImage, previewUrl }: FilePreviewProps) => {
  return (
    <div
      className={`
        flex size-11 shrink-0 items-center justify-center overflow-hidden
        rounded-lg border border-black-transparent-300
      `}
    >
      {isImage && previewUrl ? (
        <img
          src={previewUrl}
          alt=""
          className={`pointer-events-none size-full rounded-lg object-cover`}
        />
      ) : (
        <Icon
          name="file"
          size={24}
          version="v1"
          color="var(--color-primitive-secondary)"
        />
      )}
    </div>
  );
};
